import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App.tsx";
import WebGPUChat from "./components/WebGPUChat.tsx";
import WebGPUVision from "./components/WebGPUVision.tsx";
import "./index.css";
import { ThemeProvider } from "./contexts/ThemeContext";

createRoot(document.getElementById("root")!).render(
  <ThemeProvider>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/webgpu-chat" element={<WebGPUChat />} />
        <Route path="/webgpu-vision" element={<WebGPUVision />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);
